import api from '@/services/api/config';
import status from './status';
import typ from './typ';
import gruppe from './gruppe';
// import ausfuehrung from './ausfuehrung';
import historie from './historie';
import standort from './standort';

const path = 'v1/asset-standard';

export default {
  get: (page, size, sort = null, desc = false, suche = null, kategorie = null, statusParam = null, standortParam = null, pruefungWartung = false) => api.get(path, {
    params: {
      page, size, sort, desc, suche, kategorie, status: statusParam, standort: standortParam, pruefung_wartung: pruefungWartung,
    },
  }),
  getVerknuepft: (id) => api.get(`${path}/${id}/verknuepft`),
  getById: (id) => api.get(`${path}/${id}`),
  getHistorie: (id, page, size, sort = null, desc = false) => api.get(`${path}/${id}/historie`, {
    params: {
      page, size, sort, desc,
    },
  }),
  addHistorie: (id, formData) => api.post(`${path}/${id}/historie`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  changeHistorie: (werkzeugId, historieId, formData) => api.put(`${path}/${werkzeugId}/historie/${historieId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  deleteHistorie: (werkzeugId, historieId) => api.delete(`${path}/${werkzeugId}/historie/${historieId}`),
  getDokumente: (id, page, size, sort = null, desc = false, typParam = null, suche = null) => api.get(`${path}/${id}/dokument`, {
    params: {
      page, size, sort, desc, typ: typParam, suche,
    },
  }),
  create: (werkzeug) => api.post(path, werkzeug),
  update: (id, werkzeug) => api.put(`${path}/${id}`, werkzeug),
  addDocument: (id, formData) => api.post(`${path}/${id}/dokument`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  }),
  delete: (id) => api.delete(`${path}/${id}`),
  standort,
  status,
  typ,
  gruppe,
  // ausfuehrung,
  historie,

  werkzeugnummerExists: (werkzeugnummer, id) => api.get(`${path}/nummerexists`, { params: { werkzeugnummer, id } }),
  getAnzahl() {
    return api.get(`${path}/anzahl`);
  },
};
